module.exports = __webpack_public_path__ + "static/media/FiberousVeryThinRoot2.1067bbed.png";